"use client";
import { useInView } from "motion/react";
import { useMemo, useRef } from "react";
function useSafeInView(ref, options) {
    const hasIntersectionObserver = useMemo(()=>"u" > typeof IntersectionObserver, []);
    const dummyRef = useRef(null);
    const motionIsInView = useInView(hasIntersectionObserver ? ref : dummyRef, {
        root: options?.root,
        margin: options?.margin,
        once: options?.once,
        amount: options?.amount
    });
    return hasIntersectionObserver ? motionIsInView : true;
}
export { useSafeInView };
